import { AbstractControl, ValidationErrors } from '@angular/forms';
import dayjs from 'dayjs';
import { AbstractRule } from './abstract-rule';
import { ValidationResultFactory } from './validation-result-factory';

export class DateFutureRule extends AbstractRule {
  validate(control: AbstractControl): ValidationErrors | null {
    const resultFactory = new ValidationResultFactory(
      'DateFutureRule',
      this.validationService
    );

    if (control.value) {
      if (!dayjs(control.value).isAfter(dayjs())) {
        resultFactory.addResult('DateFuture');
      }
    }

    return resultFactory.validationErrors;
  }
}
